export default {
    'squareScript': 'https://web.squarecdn.com/v1/square.js',
    'appId': 'sq0idp-EMfuFxRBnKWpZTKFVBfDMA',
    'locationId': 'LX9FNS4395CK3',
    'termsAndConditions': 'https://safee.com.au/terms-and-conditions'
};
